import React from 'react';
import T from 'prop-types';
import { Button } from 'antd';

import { MODAL_LOGIN } from '../../constants/app';

const LoginButton = ({ callback, children, className, ghost, type, updateQueryString }) => {
  const handleClick = () => {
    updateQueryString({
      modal: MODAL_LOGIN,
    });

    callback();
  };

  return (
    <Button className={className} data-cy="login-btn" ghost={ghost} onClick={handleClick} type={type}>
      {children}
    </Button>
  );
};

LoginButton.propTypes = {
  updateQueryString: T.func.isRequired,

  callback: T.func,
  children: T.node,
  className: T.string,
  ghost: T.bool,
  type: T.string,
};

LoginButton.defaultProps = {
  callback: () => {},
  children: 'Log in',
  className: '',
  ghost: false,
  type: 'link',
};

export default LoginButton;
